"use client";

import { useEffect } from "react";
import Link from "next/link";

import { Pattern } from "@rivval/icons";
import { GlitchText } from "@rivval/ui/glitch-text";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Optionally log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <main>
      <div className="pt-36">
        <section className="razor-top relative bg-yellow-500 px-4 pb-24 pt-8 sm:px-2">
          <div className="absolute inset-0 h-full w-full overflow-hidden">
            <Pattern
              className="h-full w-full"
              variant="crosses"
              size="sm"
              color="#000000"
            />
          </div>
          <div className="clip-nav container relative z-10 mx-auto bg-muted p-8">
            <div className="flex flex-col items-center justify-center text-center">
              <h2 className="razor-underline mb-4 text-4xl font-bold text-yellow-500">
                <GlitchText text="Something went wrong!" glitchDuration={500} />
              </h2>
              <p className="mb-4 text-lg">
                An error occurred while loading this page.
              </p>
              <div className="flex gap-4">
                <button
                  onClick={reset}
                  className="text-yellow-500 underline hover:text-yellow-600"
                >
                  Try again
                </button>
                <Link
                  href="/"
                  className="text-yellow-500 underline hover:text-yellow-600"
                >
                  Return Home
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}
